import { Navigate } from "react-router-dom";

function Roller() {
  const scope =
    names[(names.length * Math.random()) | 0] +
    "-of-" +
    places[(places.length * Math.random()) | 0];

  return <Navigate replace to={"/roller/" + scope.toLowerCase()} />;
}

export default Roller;

const names = [
  "Abel",
  "Adalbert",
  "Agnes",
  "Aiko",
  "Alberic",
  "Albin",
  "Almond",
  "Andreas",
  "Angela",
  "Ashe",
  "Astor",
  "Aya",
  "Azel",
  "Azura",
  "Baern",
  "Belka",
  "Berenice",
  "Biel",
  "Blair",
  "Blanche",
  "Bolan",
  "Bow",
  "Bram",
  "Brandon",
  "Bryde",
  "Cale",
  "Camilla",
  "Cassandra",
  "Celeste",
  "Cetra",
  "Cinder",
  "Clarimonde",
  "Clarissa",
  "Clemence",
  "Conner",
  "Croma",
  "Cross",
  "Crow",
  "Cynthia",
  "Daige",
  "Dale",
  "Daphne",
  "Denys",
  "Divel",
  "Edel",
  "Edgar",
  "Edna",
  "Eko",
  "Eleanor",
  "Elise",
  "Emet",
  "Eric",
  "Etrian",
  "Fabian",
  "Fedra",
  "Felicia",
  "Fenis",
  "Finn",
  "Fionne",
  "Forrest",
  "Fraan",
  "Francisca",
  "Frederick",
  "Galatea",
  "Galin",
  "Garm",
  "Gilpher",
  "Gizal",
  "Glenn",
  "Gray",
  "Gregor",
  "Grimm",
  "Gyle",
  "Halia",
  "Hanna",
  "Hanzel",
  "Harper",
  "Hera",
  "Hope",
  "Ilyen",
  "Inja",
  "Isabella",
  "Izanne",
  "Jabari",
  "Jeanne",
  "Joel",
  "Jun",
  "KaIlan",
  "Kaspar",
  "Langa",
  "Lansel",
  "Lara",
  "Laurence",
  "Lazom",
  "Leanna",
  "Leda",
  "Liam",
  "Locke",
  "Logan",
  "Loren",
  "Lucian",
  "Lulu",
  "Lumi",
  "Maha",
  "Mako",
  "Maribel",
  "Markus",
  "Minerva",
  "Miranda",
  "Momo",
  "Monica",
  "Montblanc",
  "Morgan",
  "Nadia",
  "Neela",
  "Neto",
  "Nibel",
  "Nico",
  "Noah",
  "Noor",
  "Nyles",
  "Ode",
  "Olivia",
  "Oona",
  "Orion",
  "Orne",
  "Osira",
  "Owen",
  "Pharia",
  "Prim",
  "Pyre",
  "Remora",
  "Ricard",
  "Riza",
  "Robin",
  "Rosa",
  "Royce",
  "Runo",
  "Sabine",
  "Sabra",
  "Saida",
  "Sarah",
  "Selene",
  "Silas",
  "Solomon",
  "Sonya",
  "Talon",
  "Tamara",
  "Tharja",
  "Therese",
  "Thomas",
  "Tika",
  "Toris",
  "Tristan",
  "Uma",
  "Undine",
  "Usher",
  "Valea",
  "Veronica",
  "Vikes",
  "Vincent",
  "Vosca",
  "Winter",
  "Xenia",
  "Yado",
  "Yin",
  "Ylua",
  "Yuri",
  "Zen",
  "Zima",
];

const places = [
  "Acheron",
  "Agartha",
  "Alexandria",
  "Alfheim",
  "Aquileia",
  "Argus",
  "Asteride",
  "Avalon",
  "Babel",
  "Beregand",
  "Burgo",
  "Calibar",
  "Ceren",
  "Colvand",
  "Crescentia",
  "Cymur",
  "Dagda",
  "Delos",
  "Doma",
  "Dunova",
  "Edessa",
  "Endell",
  "Entigea",
  "Ertha",
  "Feror",
  "Galatea",
  "Garaphis",
  "Ghizal",
  "Harkell",
  "HoWe",
  "Ildefort",
  "Ittia",
  "Jeriva",
  "Kemes",
  "Koga",
  "Korinth",
  "Lacria",
  "Londinium",
  "Luxor",
  "Malaba",
  "Megara",
  "Megido",
  "Nara",
  "Nethis",
  "Olcressia",
  "Oskara",
  "Pemble",
  "Pirithia",
  "Platea",
  "Quivira",
  "Regalia",
  "Relde",
  "Rimea",
  "Roston",
  "Salazar",
  "Samitra",
  "Silea",
  "Sotera",
  "Tartarus",
  "Terisia",
  "Thule",
  "Torren",
  "Ulyan",
  "Ur",
  "Valica",
  "Veleia",
  "Xanadu",
  "Yade",
  "Yssira",
  "Zepro",
];
